import React from 'react';
import { LuHeadphones } from 'react-icons/lu';
import { VertContainer, VertTypography, Col, Row, VertCollapse } from '@vertem-core/vertice-ds';
import Icon from 'components/Atoms/Icons/Icon';

// STYLES
import 'Assets/styles/default/components/LikePlus/LikePlusGeneric.less';

const LikePlusCopy = () => {
    const customMessage = process.env.REACT_APP_LIKE_PLUS_CUSTOM_2WAY_MESSAGE
    /* Renders */
    return (
        <VertContainer fluid={true} className='like-plus-copy margin-y-big'>
            <VertContainer className='like-plus-contact col-12'>
                <Row gutter={0} align={`middle`}>
                    <Col className='col-12'>
                        <VertTypography.Paragraph type='default' className='txt-paragraph font-w-400 w-100 text-left margin-top-extra-small'>
                            Em caso de perda ou roubo do seu cartão, entre em contato com a central.
                        </VertTypography.Paragraph>
                        {customMessage && (
                            <VertTypography.Paragraph type='default' className='txt-paragraph font-w-400 w-100 text-left margin-top-extra-small'>
                                {customMessage}
                            </VertTypography.Paragraph>
                        )}
                    </Col>
                    <Col className='col-12 margin-top-small'>
                        <Row gutter={0} align={`middle`}>
                            <Col className='col-auto margin-right-extra-small'>
                                <Icon className="where-use-icon lucide color-neutral-dark" size={`24px`} component={LuHeadphones} />
                            </Col>
                            <Col className='col'>
                                <VertTypography.Paragraph type='default' className='txt-medium font-w-600 w-100 text-left'>
                                    Central de atendimento
                                </VertTypography.Paragraph>
                            </Col>
                        </Row>
                    </Col>
                    <Col className='col-12'>
                        <VertTypography.Paragraph type='default' className='txt-paragraph font-w-400 w-100 text-left margin-top-small'>
                            Telefone: (11) 4020-0221
                        </VertTypography.Paragraph>
                        <VertTypography.Paragraph type='default' className='txt-paragraph font-w-400 w-100 text-left'>
                            Atendimento de segunda à sexta, das 9h às 18h.
                        </VertTypography.Paragraph>
                        <VertTypography.Paragraph type='default' className='txt-paragraph font-w-400 w-100 text-left'>
                            Exceto em feriados.
                        </VertTypography.Paragraph>
                        <VertTypography.Paragraph type='default' className='txt-paragraph font-w-400 w-100 text-left margin-top-small'>
                            Você também pode entrar em contato pelo e-mail:
                        </VertTypography.Paragraph>
                        <VertTypography.Paragraph type='default' className='txt-paragraph font-w-500 w-100 text-left'>
                            atendimento@acgsa.com.br
                        </VertTypography.Paragraph>
                    </Col>
                </Row>
            </VertContainer>
        </VertContainer>

    );
};

export default LikePlusCopy;
